'use strict';

export default function () {

  const hamburguer = document.querySelector('.hamburguer-menu')
  const menu = document.querySelector('.mobile-menu')
  const mainContainer = document.querySelector('html')

  hamburguer.addEventListener('click', () => {
    hamburguer.classList.toggle('open')
    menu.classList.toggle('active')
    mainContainer.classList.toggle('remove-scroll')
  })

  const submenu = document.querySelectorAll('.mobile-menu .menu-item-has-children')
  const open_submenu = document.querySelectorAll('.menu-item-has-children .icon-submenu')


  open_submenu.forEach((item, index) => {
    item.addEventListener('click', () => {
      submenu[index].classList.toggle('active')
    })
  })
}